export default __webpack_public_path__ + "static/media/TUV.cee8456b.svg";